import axiosInstance from "./axiosInterceptors";

export const SOCKET_EVENTS = {
    RECEIVE_MESSAGE: "message:new",
    MESSAGE_READ_LISTEN: "messageReadListen",
    SEND_MESSAGE: "message:send",
    CONVERSATION_START: "conversation:start",
    READ_MESSAGE: "readMessage",
};

export const apiRoute = {
    loginUrl: "/admin-login",
    staffLoginUrl: "/staff-login",
    parentLoginUrl: "/parent-login",
    adminProfileInfoUrl: "/admin-with-daycare-details",
    editAdminProfileUrl: "/edit-admin-via-daycare-profile",
    adminChangePasswordUrl: "/change-password",

    //staff extra API 
    managerCheckinUrl: "/check-in",
    singinKioskUrl: "/verify-kiosk-pin",
    staffActionUrl: "/record-action",
    lockScreenUrl: "/lock-unlock-kiosk-pin",
    staffProfileDetailsUrl: "/own-staff-details",
    editStaffProfileUrl: "/own-staff",
    editChildAttendanceUrl: "/update-attendance",
    markAllPresentUrl: "/marks-all-present-children",
    incidentSentParentUrl: "/send-to-parent",

    profileUrl: "/profile",
    enquiryUrl: "/daycare-enquiry",
    currentUserUrl: "/current-profile",
    roomUrl: "/room",
    roomStatusUrl: "/room-status",
    allRoomUrl: "/all-room",
    staffUrl: "/staff",
    staffStatusUrl: "/staff-employement-status",
    getstaffUrl: "/staff-data",
    getInactiveStaffUrl: "/inactive-staff-data",
    getstaffByIdUrl: "/staff-details",
    getAllStaffUrl: "/all-staff",
    getStaffRoleUrl: "/staff-role",
    staffShiftUrl: "/staff-shift",
    editTimeStampUrl: "/edit-kisosk-timestamp",
    staffShiftDetailsUrl: "/staff-shift-details",
    staffAssignRoleUrl: "/staff-assign-role",
    dashboardUrl: "/dashboard",
    staffRoleDetailsUrl: "/details-staff-assign-role",
    mealPlanRoomUrl: "/meal-plan-room",
    mealPlanUrl: "/meal",
    exportMealPlanUrl: "/print-meal-plan-html",
    mealByIdUrl: "/meal-details",
    curriculumPlanUrl: "/curriculum-planing",
    curriculumMarkUrl: "/mark-complete-curriculum",
    childrenUrl: "/children-data",
    childrenAttendanceUrl: "/child-attendance",
    inactiveChildrenUrl: "/inactive-children-data",
    childrenStatusUrl: "/children-status",
    allChildrenUrl: "/all-children",
    addChildrenUrl: "/children",
    waitingChildrenUrl: "/wait-list-children-data",
    editChildrenInfoUrl: "/children",
    relationTypeUrl: "/relation-type",
    childrenDetailsUrl: "/children-details",
    childGuardianUrl: "/children-with-guardian",
    curriculumCategoryUrl: "/category",
    ChildInfoUrl: "/children-other-info",
    newsLetterUrl: "/news-letter",
    newsLetterByIdUrl: "/news-letter-via-id",
    newsLetterDetailsUrl: "/details-news-letter",
    invoiceUrl: "/invoice",
    updateStatusBillUrl: "/update-status",
    invoiceDetailsUrl: "/invoice-details",
    staffViaIdUrl: "/staff-via-id",
    activityUrl: "/activity",
    activityDetailsUrl: "/activity-details",
    uploadDocumentUrl: "/upload-documents",
    eventUrl: "/event",
    eventByIdUrl: "/event-details",
    incidentBehaviorUrl: "/incident-behavior",
    teachersUrl: "/staff-teacher-list",
    incidentByIdUrl: "/details-incident-behavior",
    staffManagerUrl: "/staff-manager-list",
    leaveRequestUrl: "/leave-request",
    leaveRequestActionUrl: "/leave-status",
    myAttendanceUrl: "/my-attendence",
    leaveUrl: "/apply-leave",
    ownStaffRoleUrl: "/remove-own-staff-role",
    preStaffRoleUrl: "/pre-selected-role",
    childAttendanceUrl: "/children-attendance-daily-report",
    AttendanceStatusUrl: "/update-attendance",
    kiosPinExistUrl: "/is-kios-sign-in-pin-exits",
    payrollUrl: "/payrole",
    payrollByIdUrl: "/payrole-details",
    childDailyReportUrl: "/daily-report",
    payrollCalulationUrl: "/payrole-helper",
    cmsUrl: "/cms",
    recentsActivityUrl: "/recent-activity",
    complianceStatusUrl: "/compliance-status",
    leaveCalenderUrl: "/leave-calender",
    pendingStatusUrl: "/actions",
    assignkioskUrl: "/get-kiosk-access",
    indicatorUrl: "/indicator-list",

    //Parents extra API
    childRecordUrl: "/get-child-record",
    selectedChildUrl: "/select-child",
    emergencyContactUrl: "/emergency-contact",
    authorisedPickupUrl: "/authorised-pickup",
    notAuthorisedPickupUrl: "/not-authorised-pickup",
    parentProfileDetailsUrl: "/children-details-web",
    editParentChildUrl: "/children",

    //admin dashboard 
    todayChildrenUrl: "/dashboard-today-children",
    staffCoverageChartUrl: "/dashboard-staff-coverage",
    billingAlertUrl: "/dashboard-billing-alerts",
    needAttentionUrl: "/dashboard-need-attention",
    todayAttendanceUrl: "/dashboard-today-attendance",
    peopleOnLeaveUrl: "/dashboard-people-and-leave",
    upcomingEventUrl: "/dashboard-upcomming-events",
    dashRoomStatusUrl: "/dashboard-room-status",
    actionInboxUrl: "/dashboard-action-inbox",
    dashboardNoteUrl: "/dashboard-note",

    //Staff dashboard
    staffCountDataUrl: "/staff-dashboard-count-data",
    staffRecentActivityUrl: "/staff-dashboard-recent-activity",

    //parent dashboard
    childProgressUrl: "/dashboard-children-progress",
    childUpcomingEventUrl: "/dashboard-upcoming-events",
    childCurriculumStatusUrl: "/dashboard-curriculum-status",
    childIncidentUrl: "/dashboard-incident-behavior",
    childUnpaidInvoiceUrl: "/dashboard-unpaid-invoice",
    childWeeklyAttendanceUrl: "/dashboard-weekly-attendance",
    childMealPlanUrl: "/dashboard-meal-plan-status",
    childNewsLetterUrl: "/dashboard-news-letter",
    parentChilAttendanceUrl: "/dashboard-child-attendance",
    todayChildActivityUrl: "/today-activity-timeline",
    dashboardMessageUrl: "/dashboard-message",
    todayParentMessageUrl: "/dashboard-message",

    // Reports
    staffCheckInOutUrl: "/staff-clock-in-clock-out-report",
    childSigninReportUrl: "/children-sign-in-sign-out-report",
    curriculumPlanReportUrl: "/curriculum-planing-report",
    eventReportUrl: "/events-report",

    mealPlanReportUrl: "/meal-plan-report",
    roomReportUrl: "/room-report",
    childrenReportUrl: "/children-report",
    newsLetterReportUrl: "/newsletter-report",
    staffReportUrl: "/staff-report",
    incidentBehaviorsReportUrl: "/incidents-behaviors-report",
    activityReportUrl: "/activity-report",
    childInvoiceUrl: "/invoice-report",
    hrPayrollReportUrl: "/payroll-report",

    // chats 
    stafffToStatffChat: "/chat-list",
    adminToStaffChat: "/admin-chat-list",
    stafffToParentChat: "/parent-list-for-chat",
    chatHistoryUrl: "/chat-history",
    chatMediaShareUrl: "/media-share-one-to-one",


    stffListChatViewUrl: "/all-staff-profile-chat",
    parentViaStaffChatViewUrl: "/staff-id-vai-parent-chat-list",
    adminHistoryChatViewUrl: "/admin-view-chat-history",
}


//  authentication
export const adminLogin = (data) => axiosInstance.post(apiRoute.loginUrl, data);
export const staffLogin = (data) => axiosInstance.post(apiRoute.staffLoginUrl, data);
export const parentLogin = (data) => axiosInstance.post(apiRoute.parentLoginUrl, data);
export const adminChangesPassword = (data) => axiosInstance.patch(apiRoute.adminChangePasswordUrl, data);
export const managerCheckin = (data) => axiosInstance.post(apiRoute.managerCheckinUrl, data);

export const signinKioskPin = (data) => axiosInstance.post(apiRoute.singinKioskUrl, data);
export const staffActions = (data) => axiosInstance.post(apiRoute.staffActionUrl, data);
export const lockScreenActions = (data) => axiosInstance.post(apiRoute.lockScreenUrl, data);

// profile info
export const fetchProfile = () => axiosInstance.get(apiRoute.profileUrl);
export const fetchCurrentProfile = (id) => axiosInstance.get(apiRoute.currentUserUrl, { params: { adminProfileId: id } });
export const fetchStaffProfileDetails = () => axiosInstance.get(apiRoute.staffProfileDetailsUrl);
export const editStaffProfileDetails = (body) => axiosInstance.put(apiRoute.editStaffProfileUrl, body);
export const fetchAdminProfileDetails = () => axiosInstance.get(apiRoute.adminProfileInfoUrl);
export const updateAdminProfileDetails = (body) => axiosInstance.put(apiRoute.editAdminProfileUrl, body);

// enquiry 
export const AddNewEnquiry = (data) => axiosInstance.post(apiRoute.enquiryUrl, data);

// rooms
export const fetchRooms = ({ current, limit, searchParams }) => axiosInstance.get(apiRoute.roomUrl, {
    params: { itemsPerPage: limit, currentPage: current, searchData: searchParams }
});

export const fetchAllRooms = () => axiosInstance.get(apiRoute.allRoomUrl);

export const deleteRoom = (id) => axiosInstance.delete(apiRoute.roomUrl, {
    data: { roomId: id }
});

export const statusRoomToggle = (body) => axiosInstance.put(apiRoute.roomStatusUrl, body);
export const createRoom = (data) => axiosInstance.post(apiRoute.roomUrl, data);
export const updateRoom = (data) => axiosInstance.put(apiRoute.roomUrl, data);


// staff & shift

export const fetchStaff = ({ current, role, limit, searchParams, types, roomId, filterType , date}) => axiosInstance.get(apiRoute.getstaffUrl, {
    params: { itemsPerPage: limit, currentPage: current, searchData: searchParams, type: types, role: role, assignedRoomId: roomId, filterType, date }
});

export const fetchInactiveStaff = ({ current, role, limit, searchParams, types }) => axiosInstance.get(apiRoute.getInactiveStaffUrl, {
    params: { itemsPerPage: limit, currentPage: current, searchData: searchParams, type: types, role: role }
});

export const toggleStaffStatus = (body) => axiosInstance.put(apiRoute.staffStatusUrl, body);

export const fetchAllStaff = () => axiosInstance.get(apiRoute.getAllStaffUrl);

export const fetchUnAssignStaff = () => axiosInstance.get(apiRoute.ownStaffRoleUrl);

export const fetchStaffRole = (staffId) => axiosInstance.get(apiRoute.getStaffRoleUrl, {
    params: { staffId: staffId }
});
export const fetchPreStaffRole = () => axiosInstance.get(apiRoute.preStaffRoleUrl);

export const fetchStaffDetailsById = (id) => axiosInstance.get(apiRoute.staffViaIdUrl, {
    params: { staffId: id }
});

export const fetchStaffById = (staffId) => axiosInstance.get(apiRoute.getstaffByIdUrl, {
    params: { staffId: staffId }
});

export const fetchShiftById = (staffShiftId) => axiosInstance.get(apiRoute.staffShiftDetailsUrl, {
    params: { staffShiftId: staffShiftId }
});

export const fetchShaffRoleDetails = (roleId) => axiosInstance.get(apiRoute.staffRoleDetailsUrl, {
    params: { staffAssignRoleId: roleId }
});


export const deleteStaffs = (id) => axiosInstance.delete(apiRoute.staffUrl, {
    data: { staffId: id }
});

export const updateStaffTimeStamp = (body) => axiosInstance.put(apiRoute.editTimeStampUrl, body);

export const createStaff = (data) => axiosInstance.post(apiRoute.staffUrl, data);
export const staffkiosPinExist = (data) => axiosInstance.post(apiRoute.kiosPinExistUrl, data);
export const createStaffRole = (data) => axiosInstance.post(apiRoute.staffAssignRoleUrl, data);

export const createStaffShift = (data) => axiosInstance.post(apiRoute.staffShiftUrl, data);
export const updateStaff = (data) => axiosInstance.put(apiRoute.staffUrl, data);
export const updateStaffRole = (data) => axiosInstance.put(apiRoute.staffAssignRoleUrl, data);
export const updateStaffShift = (data) => axiosInstance.put(apiRoute.staffShiftUrl, data);

// dashboard
export const fetchDashboard = () => axiosInstance.get(apiRoute.dashboardUrl);
export const fetchStaffDashboard = () => axiosInstance.get(apiRoute.dashboardUrl);

// meals
export const fetchMealsPlanRoom = () => axiosInstance.get(apiRoute.mealPlanRoomUrl);

export const fetchMealsPlan = ({ limit, current, searchData, types, roomId, date }) => axiosInstance.get(apiRoute.mealPlanUrl, {
    params: { itemsPerPage: limit, currentPage: current, searchData: searchData, type: types, mealPlanRoomId: roomId, date }
});

export const fetchMealById = (mealId) => axiosInstance.get(apiRoute.mealByIdUrl, {
    params: { mealListId: mealId }
});
export const deleteMeal = (id) => axiosInstance.delete(apiRoute.mealPlanUrl, {
    data: { mealPlanId: id }
});
export const createMeal = (data) => axiosInstance.post(apiRoute.mealPlanUrl, data);
export const UpdateMeal = (data) => axiosInstance.put(apiRoute.mealPlanUrl, data);


// curriculum
export const fetchCurriculumPlan = ({ limit, current, searchParams, types, roomId, dates }) => axiosInstance.get(apiRoute.curriculumPlanUrl, {
    params: { itemsPerPage: limit, currentPage: current, searchData: searchParams, type: types, curriculumRoomId: roomId, date: dates }
});
export const deleteCurriculum = (id) => axiosInstance.delete(apiRoute.curriculumPlanUrl, {
    data: { curriculumPlaningId: id }
});

export const fetchCurriculumCategory = (types) => axiosInstance.get(apiRoute.curriculumCategoryUrl, { params: { categoryType: types } });
export const createCurriculum = (data) => axiosInstance.post(apiRoute.curriculumPlanUrl, data);
export const updateCurriculum = (data) => axiosInstance.put(apiRoute.curriculumPlanUrl, data);
export const updateStatusCurriculum = (data) => axiosInstance.put(apiRoute.curriculumMarkUrl, data);


// child
export const fetchChildrenList = ({ limit, current, searchParams, room, dob }) => axiosInstance.get(apiRoute.childrenUrl, {
    params: { itemsPerPage: limit, currentPage: current, searchData: searchParams, room: room, dob: dob }
});

export const fetchAdminChildrenAttendance = ({ limit, current, searchParams, type }) => axiosInstance.get(apiRoute.childrenAttendanceUrl, {
    params: { itemsPerPage: limit, currentPage: current, searchData: searchParams, type }
});

export const fetchInactiveChildrenList = ({ limit, current, searchParams, room, dob }) => axiosInstance.get(apiRoute.inactiveChildrenUrl, {
    params: { itemsPerPage: limit, currentPage: current, searchData: searchParams, room: room, dob: dob }
});
export const fetchWaitingChildrenList = ({ limit, current, searchParams, room, dob }) => axiosInstance.get(apiRoute.waitingChildrenUrl, {
    params: { itemsPerPage: limit, currentPage: current, searchData: searchParams, room: room, dob: dob }
});
export const fetchAllChildList = () => axiosInstance.get(apiRoute.allChildrenUrl);

export const fetchChildrenById = ({ types, id }) => axiosInstance.get(apiRoute.childrenDetailsUrl, {
    params: { type: types, childDataId: id }
});

export const fetchRelationType = () => axiosInstance.get(apiRoute.relationTypeUrl);

export const fetchChildGuardian = (childId) => axiosInstance.get(apiRoute.childGuardianUrl, { params: { childId } });
export const createChild = (data) => axiosInstance.post(apiRoute.addChildrenUrl, data);
export const createChildInfo = (data) => axiosInstance.post(apiRoute.ChildInfoUrl, data);
export const UpdateChildInfo = (data) => axiosInstance.put(apiRoute.ChildInfoUrl, data);
export const UpdateChildStatus = (data) => axiosInstance.put(apiRoute.childrenStatusUrl, data);
export const UpdateChildrenInfo = (data) => axiosInstance.put(apiRoute.editChildrenInfoUrl, data);
export const deleteChildInfo = ({ types, childId, childrenInfoId }) => axiosInstance.delete(apiRoute.ChildInfoUrl, {
    data: { type: types, childId: childId, otherChildrenInfoId: childrenInfoId }
});

// newsletter 
export const fetchNewsLetter = ({ limit, current, searchParams }) => axiosInstance.get(apiRoute.newsLetterUrl, {
    params: { itemsPerPage: limit, currentPage: current, searchData: searchParams }
});

export const fetchNewsLetterById = (_id) => axiosInstance.get(apiRoute.newsLetterByIdUrl, {
    params: { newsLetterId: _id }
});

export const fetchNewsLetterDetails = (_id) => axiosInstance.get(apiRoute.newsLetterDetailsUrl, {
    params: { newsLetterId: _id }
});

export const deleteNewsLetter = (id) => axiosInstance.delete(apiRoute.newsLetterUrl, {
    data: { newsLetterId: id }
});

export const createNewsLetter = (data) => axiosInstance.post(apiRoute.newsLetterUrl, data);
export const updateNewsLetter = (data) => axiosInstance.put(apiRoute.newsLetterUrl, data);


// invoice
export const fetchInvoice = ({ limit, current, searchParams, status, key, date, invoiceTypes }) => axiosInstance.get(apiRoute.invoiceUrl, {
    params: {
        itemsPerPage: limit, currentPage: current, searchData: searchParams, invoiceStatus: status,
        dateKey: key, date: date, invoiceType: invoiceTypes
    }
});

export const fetchInvoiceDetails = (id) => axiosInstance.get(apiRoute.invoiceDetailsUrl, {
    params: { invoiceId: id }
});

export const createInvoice = (data) => axiosInstance.post(apiRoute.invoiceUrl, data);
export const updateInvoiceStatus = (data) => axiosInstance.put(apiRoute.updateStatusBillUrl, data);
export const updateInvoice = (data) => axiosInstance.put(apiRoute.invoiceUrl, data);

// HR Payroll
export const fetchHrPayroll = (params) => axiosInstance.get(apiRoute.payrollUrl, { params });
export const fetchPayrollCalculation = ({ staffId, startDate, endDate }) => axiosInstance.get(apiRoute.payrollCalulationUrl, {
    params: { staffId, startDate, endDate }
});
export const fetchHrPayrollDetails = (id) => axiosInstance.get(apiRoute.payrollByIdUrl, {
    params: { payRollId: id }
});
export const createHrPayroll = (data) => axiosInstance.post(apiRoute.payrollUrl, data);
export const updateHrPayroll = (data) => axiosInstance.put(apiRoute.payrollUrl, data);
export const deleteHrPayroll = (id) => axiosInstance.delete(apiRoute.payrollUrl, {
    data: { payRollId: id }
});

// activity plan
export const fetchActivity = ({ limit, current, searchParams, types, dates, roomId }) => axiosInstance.get(apiRoute.activityUrl, {
    params: { itemsPerPage: limit, currentPage: current, searchData: searchParams, activityType: types, date: dates, room: roomId }
});

export const fetchActivityDetails = ({ id, types }) => axiosInstance.get(apiRoute.activityDetailsUrl, {
    params: { activityId: id, activityType: types }
});

export const deleteActivity = ({ id, types }) => axiosInstance.delete(apiRoute.activityUrl, {
    data: { activityId: id, activityType: types }
});

export const createActivity = (data) => axiosInstance.post(apiRoute.activityUrl, data);
export const updateActivity = (data) => axiosInstance.put(apiRoute.activityUrl, data);

// all statff and child documents

export const fetchAllDocuments = ({ limit, current, searchParams, types, status, room }) => axiosInstance.get(apiRoute.uploadDocumentUrl, {
    params: {
        itemsPerPage: limit, currentPage: current, searchData: searchParams, documentsType: types, selectStatus: status, room: room
    }
});
export const createDocuments = (data) => axiosInstance.post(apiRoute.uploadDocumentUrl, data);
export const updateDocuments = (data) => axiosInstance.put(apiRoute.uploadDocumentUrl, data);

export const deleteDocument = (id) => axiosInstance.delete(apiRoute.uploadDocumentUrl, {
    data: { uploadDocumentsId: id }
});

// events
export const fetchEvents = ({ limit, current, searchParams, room, dates }) => axiosInstance.get(apiRoute.eventUrl, {
    params: {
        itemsPerPage: limit, currentPage: current, searchData: searchParams,
        room: room, eventDate: dates
    }
});
export const fetchEventsById = (id) => axiosInstance.get(apiRoute.eventByIdUrl, {
    params: { eventId: id }
});
export const deleteEvent = (eventId) => axiosInstance.delete(apiRoute.eventUrl, {
    data: { eventId }
});
export const updateEvent = (data) => axiosInstance.put(apiRoute.eventUrl, data);
export const createEvent = (data) => axiosInstance.post(apiRoute.eventUrl, data);


// incident & behavior
export const fetchIncident = ({ limit, current, searchParams }) => axiosInstance.get(apiRoute.incidentBehaviorUrl, {
    params: { itemsPerPage: limit, currentPage: current, searchData: searchParams, }
});
export const fetchIncidentById = (id) => axiosInstance.get(apiRoute.incidentByIdUrl, {
    params: { incidentAndBehaviorId: id }
});

export const fetchStaffManager = () => axiosInstance.get(apiRoute.staffManagerUrl);
export const fetchStaffTeacher = () => axiosInstance.get(apiRoute.teachersUrl);
export const deleteIncident = (incidentId) => axiosInstance.delete(apiRoute.incidentBehaviorUrl, {
    data: { incidentAndBehaviorId: incidentId }
});
export const updateIncident = (data) => axiosInstance.put(apiRoute.incidentBehaviorUrl, data);
export const incidentSentParent = (data) => axiosInstance.put(apiRoute.incidentSentParentUrl, data);
export const createIncident = (data) => axiosInstance.post(apiRoute.incidentBehaviorUrl, data);


// Leaves Request
export const fetchLeaveRequest = ({ limit, current, searchParams }) => axiosInstance.get(apiRoute.leaveRequestUrl, {
    params: { itemsPerPage: limit, currentPage: current, searchData: searchParams, }
});
export const updateLeaveAction = (body) => axiosInstance.put(apiRoute.leaveRequestActionUrl, body);


// My Attendance
export const fetchMyAttendance = (type) => axiosInstance.get(apiRoute.myAttendanceUrl, {
    params: { type }
});

export const createLeave = (body) => axiosInstance.post(apiRoute.leaveUrl, body);
export const updateLeave = (body) => axiosInstance.put(apiRoute.leaveUrl, body);
export const delteLeave = (id) => axiosInstance.delete(apiRoute.leaveUrl, { params: { leaveId: id } });

// Child Attendance
export const fetchChildAttendance = ({ type, room }) => axiosInstance.get(apiRoute.childAttendanceUrl, {
    params: { type, roomId: room }
});
export const updateAttendanceStatus = (body) => axiosInstance.put(apiRoute.AttendanceStatusUrl, body);
export const createDailyReport = (body) => axiosInstance.post(apiRoute.childDailyReportUrl, body);
export const updateDailyReport = (body) => axiosInstance.put(apiRoute.childDailyReportUrl, body);
export const updateChildAttendance = (body) => axiosInstance.put(apiRoute.editChildAttendanceUrl, body);
export const markAllPresentChild = (body) => axiosInstance.post(apiRoute.markAllPresentUrl, body);

// CMS
export const fetchPrivacyPolicy = (type) => axiosInstance.get(apiRoute.cmsUrl, {
    params: { type }
});

export const fetchTermCondition = (type) => axiosInstance.get(apiRoute.cmsUrl, {
    params: { type }
});

export const fetchAboutus = (type) => axiosInstance.get(apiRoute.cmsUrl, {
    params: { type }
});

// REPORTS
export const fetchStaffCheckInOut = ({ month, year, userId, date, weekly, biweekly, biweeklyStartDate, biweeklyEndDate, weeklyStartDate, weeklyEndDate }) => axiosInstance.get(apiRoute.staffCheckInOutUrl, {
    params: { month, year, userId, date, weekly, biweekly, biweeklyStartDate, biweeklyEndDate, weeklyStartDate, weeklyEndDate }
});
export const fetchMealPlanReport = ({ roomId, startDate, endDate }) => axiosInstance.get(apiRoute.exportMealPlanUrl, {
    params: { roomId, startDate, endDate }
});

export const fetchChildCheckInOut = ({ childId, month, year }) => axiosInstance.get(apiRoute.childSigninReportUrl, {
    params: { childId, month, year }
});
export const fetchCurriculumReport = ({ roomId, curriculumStatus, month, year, }) => axiosInstance.get(apiRoute.curriculumPlanReportUrl, {
    params: { roomId, curriculumStatus, month, year }
});
export const fetchEventReport = ({ roomId, month, year }) => axiosInstance.get(apiRoute.eventReportUrl, {
    params: { roomId, month, year }
});
export const fetchMealReport = ({ roomId, month, year }) => axiosInstance.get(apiRoute.mealPlanReportUrl, {
    params: { roomId, month, year }
});


export const fetchRoomReport = ({ roomStatus, month, year }) => axiosInstance.get(apiRoute.roomReportUrl, {
    params: { roomStatus, month, year }
});

export const fetchChildrenReport = ({ roomId, enrollmentStatus, month, year }) => axiosInstance.get(apiRoute.childrenReportUrl, {
    params: { roomId, enrollmentStatus, month, year }
});

export const fetchNewsLetterReport = ({ status, month, year }) => axiosInstance.get(apiRoute.newsLetterReportUrl, {
    params: { status, month, year }
});


export const fetchStaffReport = ({ employmentStatus, roleName, employmentType, month, year }) => axiosInstance.get(apiRoute.staffReportUrl, {
    params: { employmentStatus, roleName, employmentType, month, year }
});

export const fetchIncidentBehaviorsReport = ({ roomId, childId, month, year }) => axiosInstance.get(apiRoute.incidentBehaviorsReportUrl, {
    params: { roomId, childId, month, year }
});

export const fetchActivityReport = ({ roomId, activityType, month, year }) => axiosInstance.get(apiRoute.activityReportUrl, {
    params: { roomId, activityType, month, year }
});

export const fetchChildBillReport = ({ roomId, childId, month, year }) => axiosInstance.get(apiRoute.childInvoiceUrl, {
    params: { roomId, childId, month, year }
});

export const fetchHrPayrollReport = ({ staffId, month, year }) => axiosInstance.get(apiRoute.hrPayrollReportUrl, {
    params: { staffId, month, year }
});


// RECENT
export const fetchRecentActivity = () => axiosInstance.get(apiRoute.recentsActivityUrl);
export const fetchComplianceStatus = () => axiosInstance.get(apiRoute.complianceStatusUrl);
export const fetchLeaveCalender = () => axiosInstance.get(apiRoute.leaveCalenderUrl);
export const fetchPendingActions = (params) => axiosInstance.get(apiRoute.pendingStatusUrl, { params });

//Parent 
export const fetchChildRecord = () => axiosInstance.get(apiRoute.childRecordUrl);
export const updateSelectedChild = (body) => axiosInstance.put(apiRoute.selectedChildUrl, body);


//Parent Emergency contact 
export const fetchEmergencyContact = (searchParams) => axiosInstance.get(apiRoute.emergencyContactUrl, { params: { searchData: searchParams, } });
export const createEmergencyContact = (data) => axiosInstance.post(apiRoute.emergencyContactUrl, data);
export const updateEmergencyContact = (data) => axiosInstance.put(apiRoute.emergencyContactUrl, data);
export const removeEmergencyContact = (id) => axiosInstance.delete(apiRoute.emergencyContactUrl, { data: { emergencyId: id } });

//Parent Authorised Pickup
export const fetchAuthorisedPickup = (searchParams) => axiosInstance.get(apiRoute.authorisedPickupUrl, { params: { searchData: searchParams, } });
export const createAuthorisedPickup = (data) => axiosInstance.post(apiRoute.authorisedPickupUrl, data);
export const updateAuthorisedPickup = (data) => axiosInstance.put(apiRoute.authorisedPickupUrl, data);
export const removeAuthorisedPickup = (id) => axiosInstance.delete(apiRoute.authorisedPickupUrl, { data: { authorisedId: id } });

//Parent not Authorised Pickup
export const fetchUnauthorisedPickup = (searchParams) => axiosInstance.get(apiRoute.notAuthorisedPickupUrl, { params: { searchData: searchParams, } });
export const createUnauthorisedPickup = (data) => axiosInstance.post(apiRoute.notAuthorisedPickupUrl, data);
export const updateUnauthorisedPickup = (data) => axiosInstance.put(apiRoute.notAuthorisedPickupUrl, data);
export const removeUnauthorisedPickup = (id) => axiosInstance.delete(apiRoute.notAuthorisedPickupUrl, { data: { authorisedId: id } });

//Parent child profile
export const fetchParentProfileDetails = () => axiosInstance.get(apiRoute.parentProfileDetailsUrl);
export const editPrentChildDetails = (body) => axiosInstance.put(apiRoute.editParentChildUrl, body);


export const fetchAssignkiosk = ({ limit, current, searchParams }) => axiosInstance.get(apiRoute.assignkioskUrl, {
    params: { itemsPerPage: limit, currentPage: current, searchData: searchParams, }
});
export const fetchIndicatorDate = ({ month, year, type, activityType }) => axiosInstance.get(apiRoute.indicatorUrl, { params: { month, year, type, activityType } });

//admin dashboard
export const fetchDashboardCountData = (params) => axiosInstance.get(apiRoute.todayChildrenUrl, { params });
export const fetchDashboardStaffCoverage = (params) => axiosInstance.get(apiRoute.staffCoverageChartUrl, { params });
export const fetchDashboardBillingAlerts = (params) => axiosInstance.get(apiRoute.billingAlertUrl, { params });
export const fetchDashboardNeedAttention = (params) => axiosInstance.get(apiRoute.needAttentionUrl, { params });
export const fetchDashboardPeopleLeave = (params) => axiosInstance.get(apiRoute.peopleOnLeaveUrl, { params });
export const fetchDashboardTodayAttendance = (params) => axiosInstance.get(apiRoute.todayAttendanceUrl, { params });
export const fetchDashboardUpcomingEvents = (params) => axiosInstance.get(apiRoute.upcomingEventUrl, { params });
export const fetchDashboardRoomStatus = (params) => axiosInstance.get(apiRoute.dashRoomStatusUrl, { params });
export const fetchDashboardActionInbox = () => axiosInstance.get(apiRoute.actionInboxUrl);

export const fetchDashboardNotes = (params) => axiosInstance.get(apiRoute.dashboardNoteUrl, { params });
export const createDashboardNote = (body) => axiosInstance.post(apiRoute.dashboardNoteUrl, body);
export const deleteDashboardNote = (id) => axiosInstance.delete(apiRoute.dashboardNoteUrl, { data: { noteId: id } });

//staff dashboard
export const fetchStaffDashboardCountData = () => axiosInstance.get(apiRoute.staffCountDataUrl);
export const fetchStaffDashboardRecentActivity = () => axiosInstance.get(apiRoute.staffRecentActivityUrl);
export const fetchParentDashboardAttendance = () => axiosInstance.get(apiRoute.parentChilAttendanceUrl);

//  chats 
export const fetchStaffToStaffChatList = (params) => axiosInstance.get(apiRoute.stafffToStatffChat, { params })
export const fetchAdminToStaffChatList = (params) => axiosInstance.get(apiRoute.adminToStaffChat, { params })
export const fetchStaffToParentChatList = (params) => axiosInstance.get(apiRoute.stafffToParentChat, { params })
export const fetchChatHistoryList = (params) => axiosInstance.get(apiRoute.chatHistoryUrl, { params })
export const addMediaShare = (body) => axiosInstance.post(apiRoute.chatMediaShareUrl, body)

export const fetchStffListChatView = (params) => axiosInstance.get(apiRoute.stffListChatViewUrl, { params })
export const fetchParentViaStaffChatView = (params) => axiosInstance.get(apiRoute.parentViaStaffChatViewUrl, { params })
export const fetchAdminHistoryChatView = (params) => axiosInstance.get(apiRoute.adminHistoryChatViewUrl, { params })